module.exports = __webpack_public_path__ + "img/hotelFamily-1.7d9a2dc4.jpg";